export const textfield = {
    base: {
        background: "#303030",
        border: "thin solid #5e5e5e",
        color: "cyan",
    }
}